export default {
    tagText: "Project Management",
    isSelected: false,
    tagBackgroundColor: "auto",
    tagValue: null,
    overridePageCluster: null,
    overridePageSubCluster: null,
    galleryImage: null
};
